import React from 'react';
import { Box, Grid, Paper, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import RemoveIcon from '@mui/icons-material/Remove';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
const StatusRow = ({ label, value, color, icon }) => {
  return (
    <Box
      sx={{
        backgroundColor: `${color}14`,
        borderRadius: 2,
        px: 1.5,
        py: 1,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          {icon}
          <Typography variant="body2">{label}</Typography>
        </Stack>

        <Typography variant="body2" fontWeight={600} sx={{ color }}>
          {value}
        </Typography>
      </Stack>
    </Box>
  );
};

const PerfomanceSnapShot = ({ data }) => {
  const { score = 0, positive = 0, neutral = 0, needsAttention = 0 } = data;
  return (
    <>
      {/* Header */}
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        Performance Snapshot (vs Same Period Last Year)
      </Typography>
      <Stack direction="row" spacing={3} alignItems="center">
        {/* Circle */}
        <Box
          sx={{
            position: 'relative',
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: `conic-gradient(
              #2e7d32 ${score * 3.6}deg,
              #e0e0e0 0deg
            )`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: 90,
              height: 90,
              borderRadius: '50%',
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h6" fontWeight={700}>
              {score}/100
            </Typography>

            <Typography
              variant="caption"
              sx={{
                color: '#2e7d32',
                fontWeight: 600,
              }}
            >
              Good
            </Typography>
          </Box>
        </Box>

        {/* Right Side */}
        <Stack spacing={1} flex={1}>
          <StatusRow
            label="Positive"
            value={positive}
            color="#2e7d32"
            icon={<TrendingUpIcon sx={{ color: '#2e7d32', fontSize: 18 }} />}
          />

          <StatusRow
            label="Neutral"
            value={neutral}
            color="#ed6c02"
            icon={<RemoveIcon sx={{ color: '#ed6c02', fontSize: 18 }} />}
          />

          <StatusRow
            label="Needs Attention"
            value={needsAttention}
            color="#d32f2f"
            icon={<TrendingDownIcon sx={{ color: '#d32f2f', fontSize: 18 }} />}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default PerfomanceSnapShot;
